export default {"src":"/_next/static/media/filter-icon.e070b838.svg","height":24,"width":24};